import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Search, Icon } from "semantic-ui-react";
import { Grid } from "@mui/material";
import { Switch } from "antd";

import Loader from "../../Global/Loader";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import DetailModal from "./components/detailModal";
import { useEntities } from "./hooks";
import Swal from "sweetalert2";
import "./styles.scss";
import Table from "./components/table";
import { moduleActions } from "../../Global/Permission/constants";
import { validatePermission } from "../PurchaseOrder/info/components/general/utils/validatePermission";
import createModal from "../Components/ModalV2";

const IMGEntities =
  "https://magiclog.blob.core.windows.net/europartnerspic/ePoint_entidades_icon.svg";

const AssociationOfEntities = ({ lang, t, _rolId: rolId, clients }) => {
  const { filterEntities, loading, handleFilterEntities, getEntities } =
    useEntities(clients, rolId);
  const [entity, setEntity] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [search, setSearch] = useState("");
  const [associated, setAssociated] = useState(false);
  const [successAssociated, setSuccessAssociated] = useState(false);

  const handleSearchChange = (_e, { value }) => {
    setSearch(value);
    handleFilterEntities(value, associated);
  };

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  function toggleSucces() {
    setSuccessAssociated(!successAssociated)
  }

  const handleClickRow = (value) => {
    if (
      validatePermission(rolId, moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE)
    ) {
      setEntity(value);
      toggleModal();
    }
  };

  const handleAssociatedChange = () => {
    setAssociated(!associated);
    handleFilterEntities(search, !associated);
  };

  const handleAssociate = async (associate) => {
    toggleSucces()
    setOpenModal(false);
    // Swal.fire({
    //   icon: associate ? "success" : "error",
    //   confirmButtonColor: "#0561fc",
    //   confirmButtonText: "Ok",
    //   html: `<div class="text-center euro-title-form">
    //   ${t(
    //     associate
    //       ? "associationEntities.associateMessage"
    //       : "associationEntities.associateError"
    //   )}
    //   </div>`,
    //   customClass: {
    //     confirmButton: 'custom-width-btn swal'
    //   }
    // });
    if (associate) {
      await getEntities(search, associated);
    }
  };

  const columns = [
    {
      label: "",
      key: "association",
      dataIndex: "association",
      width: 50,
      render: (_text, record) => (
        <div className="text-center">
          <span
            className={
              record?.EntityRelationshipId ? "dot bg-green" : "dot bg-red"
            }
          />
        </div>
      ),
    },
    {
      title: t("associationEntities.table.header.company"),
      key: "CustomerEP", //
      dataIndex: "CustomerEP",
    },
    {
      title: t("associationEntities.table.header.entityName"),
      key: "CustomerEntityName",
      dataIndex: "CustomerEntityName",
      width: 180,
    },
    {
      title: t("associationEntities.table.header.entityType"),
      key: "RecordType",
      dataIndex: "RecordType",
      width: 130,
    },
    {
      title: t("associationEntities.shared.epEntityName"),
      key: "CustomerEPName",
      dataIndex: "CustomerEPName",
    },
    {
      title: t("associationEntities.shared.epEntityAddress"),
      key: "CustomerEPAddress",
      dataIndex: "CustomerEPAddress",
    },
  ];

  if (loading) return <Loader />;
  return (
    <ContentWrapper>
      <div className="content-heading">
        <span className="icon-entity-association icon-header" />
        {t("associationEntities.title")}
      </div>
      <Card>
        <CardBody
          className={
            !validatePermission(
              rolId,
              moduleActions.ASSOCIATION_OF_ENTITIES_ASSOCIATE
            ) && "no-clickeable"
          }
        >
          <Grid style={{ marginLeft: '10px' }} container gap="1rem" alignItems="center" rowGap={"1rem"}>
            <Grid item xs={4}>
              <Search
                // size="mini"
                className="marginLeftMinus"
                input={{
                  icon: (
                    <Icon
                      name="icon-search"
                      style={{ fontSize: "21px", marginLeft: '-17px', marginTop: '2px' }}
                    />
                  ),
                  iconPosition: "left",
                  fluid: true,
                }}
                // input={{ icon: "search", iconPosition: "left", fluid: true }}
                placeholder={t("associationEntities.shared.search")}
                value={search}
                open={false}
                name="search"
                onSearchChange={handleSearchChange}
              />
            </Grid>
            <Grid item xs={6}>
              <div className="row" style={{ gap: "1rem", marginLeft: '3px' }}>
                <Switch
                  className="form-input-switch"
                  checked={associated}
                  onChange={handleAssociatedChange}
                />
                <label className="label-euro bold">
                  {t("associationEntities.notAssociated")}
                </label>
              </div>
            </Grid>
          </Grid>
          <Table
            columns={columns}
            data={filterEntities}
            loading={loading}
            handleClickRow={handleClickRow}
            handleSearch={handleFilterEntities}
            showSearch={false}
            placeholderSearch={t("associationEntities.shared.search")}
            pageSize={10}
          />
        </CardBody>
      </Card>
      {entity && (
        <DetailModal
          open={openModal}
          toggle={toggleModal}
          entity={entity}
          handleAssociate={handleAssociate}
          t={t}
        />
      )}
      {createModal({
        isModalOpen: successAssociated,
        titleModal: 'Success',
        type: 'success',
        component: (
          <>
            <div className="col-12" style={{ textAlign: "center" }}>
              <p>{t("associationEntities.associateMessage")}</p>
            </div>
          </>
        ),
        buttons: [
          {
            text: "Ok",
            onClick: toggleSucces,
            type: "primary",
          },
        ],
        onCancel: toggleSucces
      })}
    </ContentWrapper>
  );
};

const mapStateToProps = (state) => {
  return ({
    lang: state.header.lang,
    clients: state.header.clients
  });
};
const mapDispatchToProps = () => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(withRouter(AssociationOfEntities)));
